import { faCheckCircle, faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Radio } from '@mui/material';
import clsx from 'clsx';
import getCardIcon from 'hooks/useCardIcon';
import React from 'react';
import { PaymentMethod } from 'types/PaymentMethod';

import classes from './SelectableCreditCard.module.scss';

interface SelectableCreditCardProps {
    card: PaymentMethod;
    selected: boolean;
    onSelect: (card: PaymentMethod) => void;
    disabled?: boolean;
}

export const SelectableCreditCard: React.FC<SelectableCreditCardProps> = ({
    card,
    selected,
    onSelect,
    disabled = false
}) => {
    const isClickable = !card.expired && !disabled;

    const handleClick = () => {
        if (isClickable) {
            onSelect(card);
        }
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.selected]: selected,
                [classes.disabled]: !isClickable
            })}
            onClick={handleClick}
        >
            <div className={classes.cardLeft}>
                <img src={getCardIcon(card.brand)} alt="Card icon" className={classes.cardIcon} />
                <span className={classes.cardNumber}>
                    &bull;&bull;&bull;&bull; {card.lastDigits}
                </span>

                {card.primary && !card.expired && (
                    <span className={clsx(classes.primaryBadge, classes.badgeMobile)}>Primary</span>
                )}

                {card.expired && (
                    <span className={clsx(classes.expiredBadge, classes.badgeMobile)}>
                        <FontAwesomeIcon icon={faCircleExclamation} /> Expired
                    </span>
                )}
            </div>

            <div className={classes.cardCenter}>
                <span className={classes.expirationText}>
                    Exp. {String(card.expirationMonth).padStart(2, '0')}/{card.expirationYear}
                </span>

                {card.primary && !card.expired && (
                    <span className={clsx(classes.primaryBadge, classes.badgeDesktop)}>
                        Primary
                    </span>
                )}

                {card.expired && (
                    <span className={clsx(classes.expiredBadge, classes.badgeDesktop)}>
                        <FontAwesomeIcon icon={faCircleExclamation} /> Expired
                    </span>
                )}
            </div>

            {isClickable && (
                <div className={classes.cardRight}>
                    <Radio
                        disableRipple
                        checked={selected}
                        checkedIcon={
                            <FontAwesomeIcon icon={faCheckCircle} className={classes.checkIcon} />
                        }
                        onChange={() => onSelect(card)}
                    />
                </div>
            )}
        </div>
    );
};
